/**
 * 发起违约
 */
import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import Api from '@/services';
import { notification } from 'antd';
const initState = {
    choosedDealers: undefined,
    defaultType: [],
    defaultOriginator: [],
    showBreakContract: false,
    callback: null,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 发起违约 */
        doBreakContract(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                return Api.order.breakContract(payload).then((_r) => {
                    return _r;
                }).catch((_e) => {
                    return false;
                });
            });
        },
        defaultType() {
            return __awaiter(this, void 0, void 0, function* () {
                yield Api.base.getKeyValue({
                    typeId: 111,
                })
                    .then((res) => {
                    this.SET_STATE({
                        defaultType: res,
                    });
                });
            });
        },
        defaultOriginator() {
            return __awaiter(this, void 0, void 0, function* () {
                yield Api.base.getKeyValue({
                    typeId: 113,
                })
                    .then((res) => {
                    this.SET_STATE({
                        defaultOriginator: res,
                    });
                });
            });
        },
        /** 点击确定 */
        handleOk(payload, { update, state, rootState }) {
            const { orderId } = state;
            payload.form.validateFields((err, values) => {
                if (!err) {
                    const _params = {
                        businessNum: orderId,
                        breachType: values.breakContractType,
                        luanchUserTag: values.breakContractReason,
                        breachRemark: values.remark,
                    };
                    // 请求撮合成交接口
                    this.doBreakContract(_params).then((_r) => {
                        if (_r) {
                            // 有 获取全部值 请求数据 成功后
                            notification.success({
                                message: '发起违约成功',
                            });
                            this.CloseModal();
                            this.RESET_STATE();
                            state.callback && state.callback(state.orderId);
                            payload.form.resetFields();
                        }
                        else {
                            notification.error({
                                message: '发起违约失败',
                            });
                        }
                    }).catch((err) => {
                        notification.error({
                            message: '发起违约失败',
                        });
                    });
                }
            });
        },
        /** 点击取消或叉号 */
        handleCancel(payload, { update, state, rootState }) {
            this.RESET_STATE();
            dispatch.searchDealers.RESET_STATE();
            payload.form.resetFields();
            this.CloseModal();
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                state[key] = payload[key];
            });
        },
        ShowModal(state, { orderId, callback }) {
            state.showBreakContract = true;
            state.orderId = orderId;
            state.callback = callback;
        },
        CloseModal(state) {
            state.showBreakContract = false;
        },
    },
});
